module.exports = __webpack_public_path__ + "static/img/kyelogo.dec641e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kyelogo.png
// module id = 406
// module chunks = 2